{
  "$id": "wealthlane://forms/release/ui",
  "semanticId": "releaseForm",
  "page": {
    "goBack": true
  },
  "wrapper": {
    "bordered": true
  },
  "submitBar": {
    "submitLabel": "Select Release Item",
    "align": "start",
    "hideCancel": true
  },
  "modes": {
    "create": {
      "page": {
        "title": "Create Release"
      }
    },
    "edit": {
      "page": {
        "title": "Edit Release"
      },
      "submitBar": {
        "submitLabel": "Save Detail",
        "align": "start",
        "hideCancel": true
      }
    }
  },
  "layout": [
    {
      "rowId": "releaseDetail",
      "title": "Release Detail",
      "fields": [
        {
          "scope": "#/properties/name",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 200,
          "maxWidthPx": 600
        },
        {
          "scope": "#/properties/expectedReleaseDate",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 160,
          "maxWidthPx": 240
        },
        {
          "type": "stack",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 200,
          "maxWidthPx": 320,
          "gap": 8,
          "style": { "--ui-checkbox-label-size": "13px", "--ui-checkbox-label-lh": "1.4" },
          "stackFields": [
            { "scope": "#/properties/ignoreBrokerage" },
            { "scope": "#/properties/soldShareOnlyToBroker" }
          ]
        },
        {
          "type": "spacer",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 200,
          "maxWidthPx": 200
        },
        {
          "scope": "#/properties/bulkExecutionName",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 240,
          "maxWidthPx": 600,
          "startNewRow": true
        },
        {
          "scope": "#/properties/description",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 240,
          "maxWidthPx": 600,
          "startNewRow": true
        }
      ]
    }
  ]
}
